import client from "./client";

export default {

    async getVendors(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/vendors', filters)));
    },
    async getVendor(id) {
        return client.parseResponse(await client.get('/vendors/' + id));
    },
    async createVendor(data) {
        return client.parseResponse(await client.post('/vendors', data))
    },
    async editVendor(data) {
        return client.parseResponse(await client.put('/vendors/' + data.id, data))
    },
    async deleteVendor(data) {
        return client.parseResponse(await client.delete('/vendors/' + data.id))
    },

    async exportVendorsReport(filters) {
        return client.parseResponse(await client.get('/export-vendors', filters, {responseType: 'blob'}));
    }
}
